export const matchType = <T extends string, R>(
  value: T,
  matcher: Record<T, R>
): R => {
  return matcher[value];
};
